<template>
  <vx-card :class="isActive ? 'active' : 'inactive'" :noShadow="!isActive">
    <div class="flex justify-between items-center">
      <div class="flex items-start text-left w-full md:w-11/12">
        <div class="card-image">
          <img
            :src="
              isActive
                ? $options.MY_PATH[currentPath].coloredImageUrl
                : $options.MY_PATH[currentPath].greyImageUrl
            "
            width="52px"
            height="52px"
          />
        </div>
        <div class="text-left">
          <p class="path-heading mb-2">
            {{
              $t(`alex.pathNames.${currentPath}.heading`)
            }}
          </p>
          <h5 class="mb-2">
            {{ $t(`alex.pathNames.${currentPath}.shortDescription`,  {
                orgName: organizationName,
              }) }}
          </h5>
          <p class="path-long-description">
            {{ $t(`alex.pathNames.${currentPath}.longDescription`) }}
          </p>
        </div>
      </div>
      <div class="card-action w-1/12">
        <img
          v-if="isActive"
          src="../../../../../assets/images/icons/alex/arrow_right_red.svg"
          width="45px"
          class="cursor-pointer"
          height="auto"
          @click="$emit('rightArrowClicked')"
        />
        <img
          v-else
          src="../../../../../assets/images/icons/alex/arrow_right_grey.svg"
          width="45px"
          height="auto"
        />
      </div>
    </div>
  </vx-card>
</template>
<script>
import { MY_PATH } from "@/assets/data/alex";
export default {
  MY_PATH,
  name: "MyPathCard",
  props: {
    currentPath: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    organizationName() {
      return this.$store.state.organization.orgData.name;
    },
  },
};
</script>
<style scoped>
p {
  line-height: unset;
  font-size: unset;
}
h5 {
  font-weight: bold;
}
.inactive div.card-image {
  background-color: rgba(181, 177, 177, 0.1) !important;
}
.active div.card-image {
  background-color: rgba(242, 147, 0, 0.08);
}

.card-image {
  margin-right: 1.25rem;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.s-head {
  margin-bottom: 0.2rem;
}

.active p.path-heading {
  color: #f29300;
}

.active h5 {
  color: #231d4f;
}
.active p.path-long-description {
  color: #848199;
}
.inactive h5,
.inactive p {
  color: #ccc !important;
}
.vx-card.inactive {
  border: 1px solid #eaf1fb;
}
</style>
